// 首页
import homeManage from '@/views/webViews/views/homePageComponents/locale/en-US';

export default {
  'oldOfficialSite': 'Old official site',
  'homeManage.infoPlatform': 'Info platform',
  'homeManage.email': 'Email login',
  'placeholder': 'Please enter keywords',

  'TotalS': 'Total',
  'stripS': 'StripS',
  'Goto': 'Goto',
  'pageS': 'page',
  ...homeManage,
};
